import { Injectable } from '@angular/core';

export interface SheetFocusPoint {
  page: number;
  x: number;
  y: number;
}

/**
 * W70: the sheet on screen. The sheet viewer registers the revision it shows; a record's linked-sheet card asks it to
 * bring a point into view instead of navigating to that same sheet (which would close the record's drawer and lose
 * what is typed in it).
 */
@Injectable({ providedIn: 'root' })
export class SheetFocusService {
  private shown: { revisionUuid: string; focus: (point: SheetFocusPoint | null) => void } | null = null;

  /** The viewer shows this revision; the returned function unregisters it (only if it is still the one shown) */
  register(revisionUuid: string, focus: (point: SheetFocusPoint | null) => void): () => void {
    const entry = { revisionUuid, focus };
    this.shown = entry;
    return () => {
      if (this.shown === entry) {
        this.shown = null;
      }
    };
  }

  /** True when that revision is on screen: it scrolled the point into view, so there is nothing to navigate to */
  focus(revisionUuid: string | null | undefined, point: SheetFocusPoint | null): boolean {
    if (!revisionUuid || this.shown?.revisionUuid !== revisionUuid) {
      return false;
    }
    this.shown.focus(point);
    return true;
  }
}
